import React from 'react'

export default function Layout({ account, children }) {
  return (
    <div className="min-h-screen bg-sky-900">
      <main className='max-w-2xl mx-auto' aria-label={account?.name ? `${account.name} ordering` : 'Guest ordering'}>
        {children}
      </main>
    </div>
  )
}
